import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { computed, inject, Injectable } from '@angular/core';

import { PaymentUtils } from '@app/utilities/payment.util';
import { PaymentStoreSelector } from '@app/common/selectors/payment.selector';
import { PAYMENT_METHODS } from '@config/payment-methods.config';
import { PAT_PAYMENT_METHODS } from '@config/pat-payment-methods.config';
import { PaymentService } from '@core/services/payment/payment.service';

@Injectable({ providedIn: 'root' })
export class PaymentStoreRefiner {
  private readonly selector = inject(PaymentStoreSelector);
  private readonly paymentService = inject(PaymentService);

  readonly selectPaymentMethodsWithDescriptors$ = combineLatest([
    this.selector.selectMethods$,
    this.paymentService.digitalWalletsVersion$,
  ]).pipe(
    map(([descriptors]) => PaymentUtils.mapMethodsWithDescriptors(descriptors, PAYMENT_METHODS)),
  );

  readonly selectPaymentMethodsWithDescriptors = computed(() => {
    // Re-run when wallet availability changes after lazy Stripe load
    this.paymentService.digitalWalletsVersion();
    const descriptors = this.selector.selectMethods();
    return PaymentUtils.mapMethodsWithDescriptors(descriptors, PAYMENT_METHODS);
  });

  selectPatPaymentMethodsWithDescriptors = combineLatest([
    this.selector.selectMethods$,
    this.paymentService.digitalWalletsVersion$,
  ]).pipe(
    map(([descriptors]) =>
      PaymentUtils.mapMethodsWithDescriptors(descriptors, PAT_PAYMENT_METHODS),
    ),
  );

  selectDoesHaveBancontactInformation = this.selector.selectBancontact.pipe(
    map(b => b.complete_name && b.email),
  );
}
